import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PageTitle from "../../components/page-title/PageTitle";
import { Button, Item, Tab } from "semantic-ui-react";
import Loader from "../../components/Loader";
import InternshipItem from "./InternshipItem";
import useMyInternships from "./useMyInternships";
import InternshipCreateModal from "./InternshipCreateModal";
import useIndustries from "../../app/hooks/useIndustries";

const MyInternshipPage = () => {
  const { t } = useTranslation();
  const [showPrevious, setShowPrevious] = useState(false);
  const { isLoading, internships, totalCount, renderPagination, reload } = useMyInternships(showPrevious);
  const { industries: allIndustries } = useIndustries();

  const panes = [
    {
      menuItem: t("my_internships.tabs.upcoming.tab_title"),
      render: () => (
        <PageTitle
          title={t("my_internships.tabs.upcoming.title") + (totalCount ? ` (${totalCount})` : "")}
          description={t("my_internships.tabs.upcoming.description")}
        >
          <InternshipCreateModal onCreate={() => reload()}>
            <Button primary>{t("internship.create_internship")}</Button>
          </InternshipCreateModal>
        </PageTitle>
      ),
    },
    {
      menuItem: t("my_internships.tabs.past.tab_title"),
      render: () => (
        <PageTitle
          title={t("my_internships.tabs.past.title") + (totalCount ? ` (${totalCount})` : "")}
          description={t("my_internships.tabs.past.description")}
        ></PageTitle>
      ),
    },
  ];

  const handleTabChange = (_: any, { activeIndex }: any) => {
    setShowPrevious(activeIndex === 1);
  };

  return (
    <>
      <Tab
        activeIndex={showPrevious ? 1 : 0}
        onTabChange={handleTabChange}
        menu={{ secondary: true, pointing: true }}
        panes={panes}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {internships.length > 0 ? (
            <>
              <Item.Group>
                {internships.map((internship) => (
                  <InternshipItem
                    key={internship.id}
                    internship={internship}
                    hideLogo
                    onUpdate={reload}
                    allIndustries={allIndustries}
                    showContactPerson
                  />
                ))}
              </Item.Group>
              {renderPagination()}
            </>
          ) : (
            t("common.no_records")
          )}
        </>
      )}
    </>
  );
};

export default MyInternshipPage;
